export default "__VITE_ASSET__4g1QHQMc__"